import { Container, Stack, Text } from "@mantine/core";

const PaginaFinal = () => {
  return (
    <Container size="sm" py="xl">
      <Stack align="center">
        <Text size="xl" fw={600}>
          Sua resposta neste formulário já foi registrada, obrigado!
        </Text>
      </Stack>
    </Container>
  );
};

export default PaginaFinal;
